import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import HelpSupportTable from './HelpSupportTable';
const HelpSupport = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Help & Support' parent='Help & Support'  />
      <Container fluid={true}>
        <Row>
          <HelpSupportTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default HelpSupport;
